
import {
  ModalBody,
  ModalHeader,
  ModalCloseButton,
} from '@chakra-ui/react'
import React from 'react'
import StripeConnectVerification from './stripeOnboarding'

export function StripePersonalDetailsModal({
  onSuccess,
  handleVerificationSuccess
}: {
  onSuccess: () => void
  handleVerificationSuccess:()=> void
}) {
  return (
    <>
      <ModalHeader>Stripe Onboarding form</ModalHeader>
      <ModalCloseButton mt={2} />
      <hr />
      <ModalBody pt={3}>
        <StripeConnectVerification onSuccess={onSuccess} handleVerificationSuccess={handleVerificationSuccess}/>
      </ModalBody>

    </>
  )
}
